/* Pezold – voraussichtliches Lieferdatum.
   Jedes Element mit der Klasse .pz-eta und data-min / data-max (Werktage ab heute)
   erhält einen Datumsbereich, z. B. "Fr., 30.10. – Di., 03.11." in der Sprache der Seite.
   Werktage: Mo–Fr ohne bundesweite Feiertage und ohne NRW-Feiertage (Fronleichnam, Allerheiligen).
   Ohne JavaScript bleibt der Ersatztext im HTML stehen (z. B. "in 5–7 Werktagen"). */
(function () {
  'use strict';

  var holidayCache = {};
  var lang = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2);
  var locale = { de: 'de-DE', en: 'en-GB', nl: 'nl-NL', fr: 'fr-FR', it: 'it-IT' }[lang] || 'de-DE';

  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  function key(date) { return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(); }

  function holidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    var set = {};
    [[1, 1], [5, 1], [10, 3], [11, 1], [12, 25], [12, 26]].forEach(function (md) { set[key(new Date(year, md[0] - 1, md[1]))] = true; });
    var easter = easterSunday(year);
    [-2, 1, 39, 50, 60].forEach(function (offset) { set[key(new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + offset))] = true; });
    holidayCache[year] = set;
    return set;
  }

  function isWorkday(date) {
    var day = date.getDay();
    if (day === 0 || day === 6) return false;
    return !holidays(date.getFullYear())[key(date)];
  }

  function addWorkdays(start, count) {
    var date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var left = count;
    while (left > 0) { date.setDate(date.getDate() + 1); if (isWorkday(date)) left -= 1; }
    return date;
  }

  function format(date) {
    try { return date.toLocaleDateString(locale, { weekday: 'short', day: '2-digit', month: '2-digit' }); }
    catch (e) { return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.'; }
  }

  function apply(root) {
    var nodes = (root || document).querySelectorAll('.pz-eta[data-min][data-max]:not([data-pz-eta-done])');
    if (!nodes.length) return;
    var today = new Date();
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var min = parseInt(node.getAttribute('data-min'), 10);
      var max = parseInt(node.getAttribute('data-max'), 10);
      if (isNaN(min) || isNaN(max) || min < 0 || max < min) continue;
      var a = format(addWorkdays(today, min));
      node.textContent = min === max ? a : a + ' – ' + format(addWorkdays(today, max));
      node.setAttribute('data-pz-eta-done', '');
    }
  }

  function init() {
    apply(document);
    if (!('MutationObserver' in window) || !document.body) return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; apply(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
